export default __webpack_public_path__ + "static/media/animation-arrow8.7dc72035.gif";